import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";

import sampleImg from "../../../../assests/images/sample.png";

const Sample = () => (
  <ContentCard
    title="SAMPLE ROUNDS"
    id="sample"
    image={sampleImg}
    imageTtitle="SAMPLE ROUNDS"
    frontText="We finished the sample rounds. In the picture you can see one of our samples,
               which is yet not perfect..."
    backTextOne="In the fashion industry the process of product development usually starts with a design idea and creating a pattern. Then comes the sewing of a first sample. The sample is checked in terms of fit, construction, materials and possible improvements. After the adjustments the second, the revised sample, is produced. This process will be repeated until the sample is approved. Then the sewing of a size set starts - the final product is produced in every size that will be offered on the market."
    backTextTwo="We had several sample rounds in Mauritius and in Berlin with Karen, our tailor and Sascha, our patternmaker. Each sample sewing was followed by fitting trials with our fitting models. We found our models literally on the streets of Mauritius and Berlin. Instead of hiring from an agency we preferred to find people who like to wear hoodies and who wanted to join SAMPELL not only for the money but for the fun of the journey. In hindsight this was a great choice. We learned a lot from our fitting models. They not only shared their personal preferences with us. They also became part of the design process and introduced new ideas and style options."
    backTextThree="Now we have finalized the pattern and are ready to go."
    imageBack2={sampleImg}
    imageTitle2="Our First Sample"
    caption="This is one of our very first sample hoodies where we put some print on to test the quality of the printing factory."
  />
);

export default Sample;



// WEBPACK FOOTER //
// ./src/components/Pages/Progress/Content/Sample.js